import styles from './FJImageToVideoButton.module.less';
import FJButton, { FJButtonType } from '../../../components/FJButton/FJButton.jsx';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import VideoGradientIcon from '../../../../assets/svg/video-gradient.svg?react';

const FJImageToVideoButton = props => {
    const { imageToVideo, isOnlyBtn = false } = props;
    return isOnlyBtn ? (
        <div className={styles.box}>
            <FJButton
                onClick={imageToVideo}
                className={classNames(styles.image_to_video_btn)}
                textClassName={styles.download_text}
                text={FJLocalStore._('image-to-video')}
                type={FJButtonType.LIGHT_GRADIENT}
                icon={<VideoGradientIcon />}
            />
        </div>
    ) : (
        <div className={styles.right_btn_box}>
            <div className={styles.box}>
                <FJButton
                    onClick={imageToVideo}
                    className={classNames(styles.image_to_video_btn)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('image-to-video')}
                    type={FJButtonType.LIGHT_GRADIENT}
                    icon={<VideoGradientIcon />}
                />
            </div>
        </div>
    );
};

export default FJImageToVideoButton;
